import { LoadingType, ModalType } from '@app-types/app';

import { clippBodyHandler } from '@helpers/utils';

import { create } from 'zustand';

type UIStoreType = {
    modal: ModalType;
    loading: LoadingType;
    showLoading: (loadingMessage: string) => void;
    hideLoading: () => void;
    hasOptionsAvailable: boolean | null;
    setHasOptionsAvailable: (hasOptions: boolean | null) => void;
};

export const uiStore = create<UIStoreType>((set) => ({
    modal: { isActive: false },
    loading: { show: false },
    showLoading: (loadingMessage: string) => {
        clippBodyHandler(true);
        set({
            loading: {
                message: loadingMessage,
                show: true,
            },
        });
    },
    hideLoading: () =>
        set(() => {
            clippBodyHandler(false);
            return { loading: { show: false } };
        }),
    hasOptionsAvailable: null,
    setHasOptionsAvailable: (hasOptions: boolean | null) => set({ hasOptionsAvailable: hasOptions }),
}));
